import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { AreYouUpdatedResponse, FcInfo } from '../interfaces/are-you-updated.interface';
import { SerialStatusResponse } from '../interfaces/keyword-search';

@Injectable({
  providedIn: 'root',
})
export class AreYouUpdatedService extends ApiService {
  public getDetailsByFC(
    reqData: AreYouUpdatedResponse
  ): Observable<AreYouUpdatedResponse> {
    return this.post<AreYouUpdatedResponse>(ROUTES.ARE_YOU_UPDATED, {
      body: reqData,
    });
  }

  public getFcInfo(
    reqData: any
  ): Observable<FcInfo> {
    return this.get<FcInfo>(ROUTES.FC_INFO, {
      params: reqData,
    });
  }



  public getSlDetails(
    slNo: any,
    payLoad: any
  ): Observable<SerialStatusResponse> {
    return this.get<SerialStatusResponse>(
      this.replacePathInfo(ROUTES.GLOBAL_SEARCH_SL_DETAILS, {
        memKey: slNo,
      }),
      {
        params: payLoad,
      }
    );
  }
  public saveIdDetails(
    reqData: any
  ): Observable<any> {
    return this.post(ROUTES.SAVE_ID_PROOF_DETAILS, {
      body: reqData,
    });
  }
  public editIdDetails(
    reqData: any
  ): Observable<any> {
    return this.put(ROUTES.UPDATE_ID_PROOF_DETAILS, {
      body: reqData,
    });
  }
}
